const forestSpeciesDB = [
  {
    name: 'Neem Tree 🌳',
    role: 'Medicinal, air purification',
    lifespan: '100+ years',
    pH: [6.0, 8.0],
    humidity: [30, 60],
    moisture: [20, 40],
  },
  {
    name: 'Banyan Tree 🌳',
    role: 'Shade provider, sacred, biodiversity hub',
    lifespan: '200+ years',
    pH: [6.0, 7.5],
    humidity: [50, 90],
    moisture: [40, 70],
  },
  {
    name: 'Peepal Tree 🌿',
    role: 'Oxygen producer, sacred',
    lifespan: '150+ years',
    pH: [6.0, 7.5],
    humidity: [30, 70],
    moisture: [20, 50],
  },
  {
    name: 'Teak Tree 🌲',
    role: 'Timber, canopy coverage',
    lifespan: '100+ years',
    pH: [6.5, 7.5],
    humidity: [40, 70],
    moisture: [30, 50],
  },
  {
    name: 'Jamun Tree 🍇',
    role: 'Fruit-bearing, wildlife support',
    lifespan: '80–100 years',
    pH: [6.0, 7.5],
    humidity: [60, 85],
    moisture: [30, 60],
  },
  {
    name: 'Mango Tree 🥭',
    role: 'Fruit, shade, bird support',
    lifespan: '100–150 years',
    pH: [6.0, 7.5],
    humidity: [50, 80],
    moisture: [40, 60],
  },
  {
    name: 'Indian Rosewood 🌸',
    role: 'Timber, medicinal, canopy',
    lifespan: '100–120 years',
    pH: [6.0, 8.0],
    humidity: [40, 80],
    moisture: [30, 60],
  },
  {
    name: 'Bael Tree 🍐',
    role: 'Medicinal, fruit-bearing',
    lifespan: '100+ years',
    pH: [6.0, 8.0],
    humidity: [40, 70],
    moisture: [30, 50],
  },
  {
    name: 'Indian Mahogany 🌳',
    role: 'Hardwood, biodiversity',
    lifespan: '120+ years',
    pH: [6.0, 7.5],
    humidity: [60, 85],
    moisture: [40, 65],
  },
  {
    name: 'Sandalwood Tree 🌳',
    role: 'Medicinal, aromatic wood',
    lifespan: '100–200 years',
    pH: [6.0, 7.0],
    humidity: [40, 70],
    moisture: [30, 50],
  },
  {
    name: 'Arjuna Tree 🌳',
    role: 'Water bank stabilizer, medicinal',
    lifespan: '100+ years',
    pH: [6.0, 7.5],
    humidity: [40, 80],
    moisture: [30, 60],
  },
  {
    name: 'Rudraksha Tree 🔮',
    role: 'Spiritual, shade',
    lifespan: '100+ years',
    pH: [6.0, 7.5],
    humidity: [50, 85],
    moisture: [30, 50],
  },
  {
    name: 'Sal Tree 🌳',
    role: 'Sacred, hardwood, forest native',
    lifespan: '100–150 years',
    pH: [5.5, 7.0],
    humidity: [60, 80],
    moisture: [40, 60],
  },
  {
    name: 'Jackfruit Tree 🌳',
    role: 'Fruit, shade, support birds',
    lifespan: '100+ years',
    pH: [6.0, 7.5],
    humidity: [50, 80],
    moisture: [40, 60],
  },
  {
    name: 'Deodar Cedar 🌲',
    role: 'Windbreak, canopy, sacred',
    lifespan: '200+ years',
    pH: [6.0, 7.5],
    humidity: [50, 80],
    moisture: [30, 60],
  },
  {
    name: 'Chestnut Tree 🌰',
    role: 'Nut bearing, wildlife support',
    lifespan: '200+ years',
    pH: [5.5, 7.5],
    humidity: [40, 70],
    moisture: [30, 60],
  },
  {
    name: 'Oak Tree 🌳',
    role: 'Biodiversity shelter, large canopy',
    lifespan: '200+ years',
    pH: [5.5, 7.0],
    humidity: [50, 80],
    moisture: [40, 70],
  },
  {
    name: 'Cork Tree 🌲',
    role: 'Fire-resistant, bark use',
    lifespan: '100+ years',
    pH: [6.0, 7.0],
    humidity: [30, 60],
    moisture: [20, 50],
  },
  {
    name: 'Tamarind Tree 🌳',
    role: 'Fruit, shade, medicinal',
    lifespan: '80–100 years',
    pH: [6.0, 8.0],
    humidity: [50, 80],
    moisture: [40, 60],
  },
  {
    name: 'Khejri Tree 🌿',
    role: 'Desert stabilizer, sacred',
    lifespan: '100–120 years',
    pH: [7.0, 8.5],
    humidity: [20, 60],
    moisture: [10, 30],
  }
];

export default forestSpeciesDB;